import { PictureColumn } from './picture.model';

class BaseData {
  sectionId: string;
  id: string;
}

export class TitleData extends BaseData {
  title: string;
  icon: string;
  isAnchor: boolean;
}

export class ParagraphData extends BaseData {
  text: string;
}

export class InfoData extends BaseData {
  title: string;
  text: string;
}

export class PictureData extends BaseData {
  pictureColumns: PictureColumn[];
}

export class InstagramData extends BaseData {
  postId: string;
}

export class MentionData extends BaseData {
  text: string;
}

export class ArticleLinkData extends BaseData {
  articleId: string;
}

export class IframeData extends BaseData {
  url: string;
  width: string = '100%';
  height: string = '500';
}

export class ButtonData extends BaseData {
  icon: string;
  text: string;
  link: string;
}
